



















import Vue from 'vue';
import { BaseButton } from "@/@shell/components/BaseButton/BaseButtonInterface";

export default Vue.extend({
    props: {
        tooltip: {
            type: Object as () => BaseButton,
            required: false
        }
    },
    methods: {
        handleClick() {
            this.$emit('click')
        }
    }
})
